<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-row>
				<v-col cols="12" md="6">
					<v-text-field ref="firstName" v-model="localData.firstName" label="نام*" :error-messages="errorMessages"
						:rules="[() => !!localData.firstName || 'نام را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field ref="lastName" v-model="localData.lastName" label="نام خانوادگی*" :error-messages="errorMessages"
						:rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="nationalCode" v-model="localData.nationalCode" label="کد ملی*" maxlength="10"
						:error-messages="errorMessages" :rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="affiliateCode" v-model="localData.affiliateCode" label="کد معرفی*"
						:error-messages="errorMessages"
						:rules="[() => !!localData.affiliateCode || 'کد معرفی را وارد کنید', () => localData.affiliateCode != 0 || 'کد معرفی نمی تواند 0 باشد']"
						required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="commissionPercent" v-model="localData.commissionPercent" label="درصد پورسانت*"
						:error-messages="errorMessages" maxlength="6"
						:rules="[() => localData.commissionPercent >= 0 || 'درصد پورسانت نمی تواند کمتر از 0 باشد', () => localData.commissionPercent <= 100 || 'درصد پورسانت نمی تواند بیشتر از 100 باشد']"
						required />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="6">
					<v-text-field ref="email" v-model="localData.email" label="ایمیل*" :error-messages="errorMessages"
						:rules="[() => !!localData.email || 'ایمیل را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field ref="username" v-model="localData.email" :disabled="true" label="نام کاربری*" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<v-text-field v-model="localData.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
						:rules="[() => !!localData.password || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages"
						:type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" hint="حداقل 8 کاراکتر"
						@click:append="show1 = !show1" />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field v-model="localData.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
						:rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']"
						:error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword"
						label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
				</v-col>
			</v-row>
			<small>لینک بازاریابی و تبلیغات:</small>
			<v-alert text color="info">
				<v-row>
					<v-col cols="12" class="text-left" style="direction: ltr;display: flex;align-items: center;">
						<v-btn @click="copyToClipborad" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
							<v-icon color="white">mdi-content-copy</v-icon>
						</v-btn>
						<span style="cursor: pointer;" @click="copyToClipborad">https://jetaqsaat.ir?aff={{ localData.affiliateCode
						}}</span>
					</v-col>
				</v-row>
			</v-alert>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="$emit('callbck', false)">
					بستن
				</v-btn>
				<v-btn color="blue" dark type="submit">
					ذخیره
				</v-btn>
			</v-card-actions>
		</v-form>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'ModifyMarketer',
		components: {
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				activeTab: 0,
				errorMessages: '',
				claims: [],
				localData: {},
				show1: false,
				show2: false,
			}
		},
		mounted() {
			this.prepareData()
		},
		computed: {
		},
		methods: {
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.localData.claims = this.claims.filter(x => x.isChecked == true)
				api.post('superadmin/marketer/' + (this.localData.id === 0 ? 'create' : 'edit'), this.localData)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('superadmin/marketer/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === 0) Object.assign(this.localData, this.data)
						})
					.catch(err => {
						toast.error(err.message)
					})

			},
			copyToClipborad() {
				const fallbackCopyTextToClipboard = () => {
					var el = document.createElement('textarea')
					el.value = text
					el.setAttribute('readonly', '')
					el.style = {
						position: 'absolute',
						left: '-9999px'
					}
					document.body.appendChild(el)
					el.select()
					document.execCommand('copy')
					document.body.removeChild(el)
					toast.success('لینک به حافظه کپی شد.')
			}
			var text = 'https://jetaqsaat.ir?aff=' + this.localData.affiliateCode
			if (!navigator.clipboard) {
				fallbackCopyTextToClipboard(text)
				return
			}
			navigator.clipboard.writeText(text).then(function () {
				toast.success('لینک به حافظه کپی شد.')
			}, function (err) {
				console.error('Async: Could not copy text: ', err)
			})
		}
	},
}
</script>
<style></style>
